import Axios from 'axios';
import { makeUrl } from '../../../utils/makeUrl';
import { getProductData } from './data';

export const addToCartRequest = async orderInfo => {
    const SITE_ID = getProductData().siteId;
    function formatFormExceptions(response = {}) {
        const exception = response.formExceptions;
        if (exception && 'maximumCartCountWithLinkError' in exception) {
            return exception.maximumCartCountWithLinkError;
        }

        if (exception && 'maximumCartCountError' in exception) {
            return exception.maximumCartCountError;
        }
        return getProductData().msgServerError;
    }
    const url = makeUrl(
        `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrder?pushSite=${SITE_ID}`
    );
    try {
        const { data: response } = await Axios.post(url, {
            catalogRefIds: orderInfo.skuId,
            productId: orderInfo.productId,
            quantity: orderInfo.quantity,
            addItemToOrderSuccessURL: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderSuccess?pushSite=${SITE_ID}`,
            addItemToOrderErrorURL: `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrderError?pushSite=${SITE_ID}`,
        });
        if (response.success === 'false') {
            return {
                success: false,
                msg: formatFormExceptions(response),
            };
        }
        return {
            success: true,
            order: response.order,
            total: response.totalCount,
            initialQuantity: orderInfo.quantity,
            isPriceWithTax: response.isPriceWithTax,
        };
    } catch (error) {
        return {
            success: false,
            msg: formatFormExceptions(),
        };
    }
};
